import { CollapsedSidebar } from "./CollapsedSidebar";
import { NestedNavBar } from "./NestedNavBar";

export const SettingsNav = () => (
  <div className="flex h-full items-stretch">
    <CollapsedSidebar />
    <NestedNavBar />
  </div>
);
